var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClip18H(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 5 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-3.6%",
    width: "118.2%",
    height: "107.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB370\\uB2C8\\uC2A4-\\uC2DC\\uC548-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD30C\\uC77C\\uCCA8\\uBD80\\uB2E8\\uACC4",
    transform: "translate(-434.000000, -109.000000)",
    stroke: "#545454",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.483614,110.927806 L438.483614,121.491373 C438.483614,123.468058 440.086034,125.070478 442.062719,125.070478 L442.062719,125.070478 C444.039405,125.070478 445.641824,123.468058 445.641824,121.491373 L445.641824,109.556822 C445.641824,108.241352 444.575425,107.174952 443.259955,107.174952 L443.259955,107.174952 C441.944484,107.174952 440.878085,108.241352 440.878085,109.556822 L440.878085,121.408879 C440.878085,122.066871 441.411493,122.600279 442.069484,122.600279 L442.069484,122.600279 C442.727476,122.600279 443.260884,122.066871 443.260884,121.408879 L443.260884,110.898725",
    id: "Path-5-Copy",
    filter: "url(#filter-1)",
    transform: "translate(442.062719, 116.122715) rotate(-315.000000) translate(-442.062719, -116.122715) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip18H);
export default __webpack_public_path__ + "static/media/icon-clip-18h.6b758dbce6737b36bf8e818e91719df6.svg";
export { ForwardRef as ReactComponent };